BoardListSidebarItemView = require 'views/boards-sidebar/board-list-sidebar-item-view'
track = require 'debug/track'
xtend = require 'xtend'
Auth = require 'db/auth'

module.exports = class BoardListSearchItemView extends BoardListSidebarItemView

  events:
    'mouseenter': 'select'
    'mouseleave': 'deselect'

  delegateEvents: (events) ->
    super(xtend(BoardListSidebarItemView::events, events || @events))

  select: ->
    @$el.addClass('selected')

  deselect: ->
    @$el.removeClass('selected')

  trackBoardClick: ->
    if @model.isMember(Auth.me())
      label = "Board (Member of)"
    else
      label = "Board (Not a Member)"

    track("Search", "Select Item", label)

  trackStarBoard: ->
    track("Search", "Star Board")

  trackUnstarBoard: ->
    track("Search", "Unstar Board")



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-search-item-view.coffee